module.exports = __webpack_public_path__ + "earmuffs_crop.jpg?f0d5fc5063a91d0850354a2b0e7917b2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/earmuffs_crop.jpg
// module id = 48
// module chunks = 0